import { useState } from 'react';
import { Button } from '../../components/Button/Button';
import { Card } from '../../components/Card/Card';
import { MoneyInput } from '../../components/MoneyInput/MoneyInput';
import { useUiStore } from '../../store/ui';
import { kr } from '../../lib/format';
import styles from './AktuelSaldo.module.css';

interface Row {
  id: number;
  name: string;
  amount: number | null;
}

const DEMO_ROWS: Row[] = [
  { id: 1, name: 'Lønkonto', amount: 23450 },
  { id: 2, name: 'Budgetkonto', amount: 8600 },
  { id: 3, name: 'Opsparingskonto', amount: 61500 },
];

export function AktuelSaldo() {
  const setToast = useUiStore((s) => s.setToast);
  const [rows, setRows] = useState<Row[]>(DEMO_ROWS);
  const [nextId, setNextId] = useState(4);

  function add() {
    setRows((prev) => [...prev, { id: nextId, name: 'Ny konto', amount: null }]);
    setNextId((n) => n + 1);
    setToast('Konto tilføjet');
  }

  function rename(id: number, name: string) {
    setRows((prev) => prev.map((r) => (r.id === id ? { ...r, name } : r)));
  }

  function editAmount(id: number, amount: number | null) {
    setRows((prev) => prev.map((r) => (r.id === id ? { ...r, amount } : r)));
  }

  function del(id: number) {
    setRows((prev) => prev.filter((r) => r.id !== id));
    setToast('Konto slettet');
  }

  const total = rows.reduce((s, r) => s + (r.amount ?? 0), 0);

  return (
    <Card>
      <div className={styles.head}>
        <h2 className={styles.title}>Aktuel saldo</h2>
        <Button onClick={add}>+ Tilføj konto</Button>
      </div>
      <p className={styles.hint}>
        Indtast hvad der står på kontiene lige nu. Bruges senere til at vise, hvor mange penge I har
        tilbage i måneden, og om I er forud eller bagud i forhold til budgettet.
      </p>
      <div className={styles.body}>
        <div className={styles.headRow}>
          <div>Konto</div>
          <div className={styles.right}>Beløb nu</div>
          <div />
        </div>
        {rows.map((r) => (
          <div key={r.id} className={styles.row}>
            <input
              className={styles.nameInput}
              value={r.name}
              onChange={(e) => rename(r.id, e.target.value)}
              onFocus={(e) => e.target.select()}
            />
            <MoneyInput value={r.amount} onCommit={(v) => editAmount(r.id, v)} placeholder="0" />
            <button
              type="button"
              className={styles.delete}
              onClick={() => del(r.id)}
              title={`Slet ${r.name}`}
              aria-label={`Slet ${r.name}`}
            >
              ×
            </button>
          </div>
        ))}
        <div className={styles.totalRow}>
          <div className={styles.totalLabel}>I alt lige nu</div>
          <div className={styles.totalValue}>{kr(total)}</div>
          <div />
        </div>
      </div>
    </Card>
  );
}
